export const RecordStatus = {
    NORMAL: 1, // 正常
    FAULT: 2, // 故障
    REPAIRING: 3, // 维修中
}

export const RecordStatusText = {
    1: '正常',
    2: '故障',
    3: '维修中',
}

export const RecordStatusOptions = [
    { value: RecordStatus.NORMAL, label: RecordStatusText[RecordStatus.NORMAL] },
    { value: RecordStatus.FAULT, label: RecordStatusText[RecordStatus.FAULT] },
    { value: RecordStatus.REPAIRING, label: RecordStatusText[RecordStatus.REPAIRING] },
]